export interface SelfRegistrationResponse {
  success: boolean;
  message: string;
  data?: any;
  error?: any;
}

export interface NonFederatedRegistrationData {
  userEmail: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  password: string;
}

const hostname = window.location.hostname;

export async function selfRegistration(
  userEmail: string, 
  isFederated: boolean,
  additionalData?: NonFederatedRegistrationData
): Promise<SelfRegistrationResponse> {
  let baseurl = '';
  
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  const payload = isFederated 
    ? { userEmail, isFederated: true }
    : { 
        userEmail, 
        isFederated: false,
        ...additionalData 
      };

  const res = await fetch(`${baseurl}/api/candidate-dashboard/self-registration`, {
    method: 'POST',
    headers: { 
      'Accept': 'application/json', 
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error(`You are not authorized to access this application.`);
  return res.json();
}